import { downgradeComponent } from '@angular/upgrade/static';
import { module } from 'angular';

import { default as HistoryMail } from './history-mail/history-mail.module.ajs';
import { default as historyPopinName, HistoryPopin } from './history-popin/history-popin.component';
import { default as HistorySocialNetwork } from './history-social-network/social-network-history.module.ajs';
import { TimelineHistoryComponent } from './timeline/timeline-history/timeline-history.component';
import { TimelineInprocessComponent } from './timeline/timeline-inprocess/timeline-inprocess.component';

export default module('contact.commons.history', [HistoryMail, HistorySocialNetwork])
  .component(historyPopinName, new HistoryPopin())
  // DOWNGRADED COMPONENT
  .directive('cngTimelineInprocess', downgradeComponent({ component: TimelineInprocessComponent }) as angular.IDirectiveFactory)
  .directive('cngTimelineHistory', downgradeComponent({ component: TimelineHistoryComponent }) as angular.IDirectiveFactory).name;
